/* eslint-disable react/no-danger */
// eslint-disable-next-line
import { h, render, Fragment } from 'preact';
import Image from '../utils/image';

export default (element, data) => {
  const Lifesharp = () =>
    data && (
      <div className="px-5 py-[30px] laptop:px-10 font-gotham">
        <div className="relative bg-black">
          <div className="laptop:absolute top-0 left-0 w-full h-full mb-[106px] laptop:mb-0">
            {data.background && (
              <Image
                srcWidths={{
                  sm: 640,
                  md: 768,
                  lg: 1024,
                  xl: 1280,
                  '2xl': 1536,
                }}
                dataHeatmapId={`lifesharp-bg-desktop-${data?.id}`}
                className="hidden laptop:block w-full h-full object-cover"
                src={data.background}
                alt={data.backgroundAlt ?? ''}
                width={data.background.width}
                height={data.background.height}
              />
            )}
            {data.backgroundMob && (
              <Image
                srcWidths={{
                  sm: 640,
                  md: 768,
                  lg: 1024,
                  xl: 1280,
                  '2xl': 1536,
                }}
                className="laptop:hidden w-full"
                src={data.backgroundMob}
                alt={data.backgroundMobAlt ?? ''}
                dataHeatmapId={`lifesharp-bg-mobile-${data?.id}`}
              />
            )}
          </div>
          <div className="px-5 pb-[22px] laptop:pt-[90px] laptop:pb-[59px] laptop:px-[72px] relative text-white">
            {data.eyebrowLogo && (
              <Image
                className="mb-2 block max-h-[22px]"
                src={data.eyebrowLogo}
                alt={data.eyebrowLogoAlt ?? 'Logo'}
                dataHeatmapId={`lifesharp-logo-${data?.id}`}
              />
            )}
            {data.eyebrowText && !data.eyebrowLogo && (
              <p className="mb-2 text-lg leading-[22px] font-[350]">
                {data.eyebrowText}
              </p>
            )}
            {data.heading && (
              <h3 className="text-2xl laptop:text-3xl leading-7 laptop:leading-[34px] mb-2 font-[600] uppercase">
                {data.heading}
              </h3>
            )}
            {data.content && (
              <div
                className="text-sm leading-5 font-[325] mb-[18px] laptop:mb-[29px] laptop:max-w-[369px]"
                dangerouslySetInnerHTML={{ __html: data.content }}
              />
            )}
            {data.ctaLink && (
              <a
                href={data.ctaLink}
                className="btn-primary-stroke-arrow-inverse"
              >
                {data.ctaText}
              </a>
            )}
          </div>
        </div>
      </div>
    );

  const init = async () => {
    render(<Lifesharp />, element);
  };

  init();
};
